import { Refresh } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import React, { useCallback } from 'react';
import { useTranslation } from "react-i18next";

import { REFRESH_TABLE, useMainDispatch } from "../../contexts/MainContext";
import { usePrimusState } from "../../contexts/PrimusContext";

export const RefreshListButton = () => {
  const { t } = useTranslation('translations');
  const mainDispatch = useMainDispatch();
  const mainDispatchCallback = useCallback(mainDispatch, [mainDispatch]);
  const { selectedList, selectedListStatus } = usePrimusState();

  const handleRefresh = () => {
    mainDispatchCallback({
      type: REFRESH_TABLE
    })
  }

  return (
    <Box>
      <Tooltip title={t('menu.actionHeader.refreshButton')}>
        <span>
          <IconButton onClick={handleRefresh} disabled={!selectedList || !selectedListStatus} size='large'>
            <Refresh fontSize="inherit" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  )
}